<template>
  <EditorialFeed
    v-bind="{ getFirstPage, getNextPage }"
    :grid-class="{
      md: false,
      sm: true,
    }"
  >
    <template #header>
      <LayoutFeedHeader>Content</LayoutFeedHeader>
    </template>
  </EditorialFeed>
</template>

<script setup lang="ts">
import {
  getAllFirstPage as getFirstPage,
  getAllNextPage as getNextPage,
} from "~/groq/editorial"

useHead({
  title: "Editorial",
})
</script>
